<template>
  <b-form
      inline
      @keydown="form.onKeydown($event)"
      @submit.prevent="handleSubmit"
  >
    <b-form-group
        :invalid-feedback="form.errors.get('name')"
        :label="$t('Name')"
        :label-for="uuid"
        :state="form.errors.has('name') ? false : null"
        class="flex-grow-1"
        label-sr-only
    >
      <b-input-group>
        <b-form-input
            :id="uuid"
            v-model="form.name"
        />
        <b-input-group-append v-if="isDirty">
          <b-btn type="submit" variant="success" :disabled="form.busy">
            <fa icon="check" />
          </b-btn>
        </b-input-group-append>
      </b-input-group>
</b-form-group>
</b-form>
</template>

<script>
import Form from 'vform';

export default {
  name: "WallNameForm",
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: new Form({
        name: this.name
      })
    }
  },
  computed: {
    isDirty() {
      return this.form.name !== this.form.originalData.name
    }
  },
  methods: {
    handleSubmit() {
        this.form.put(this.apiUrl).then(({data}) => {
          this.form = new Form({
            name: data.name
          });

          this.savedToast();
        })
    }
  }
}
</script>
